import React from "react";
import EntityList from "../EntityList/EntityList";
import { defineMessages } from "react-intl";
import {
  BLOCKAGE,
  EXTRA_TYPE,
  EXTRA_TYPE_VARIANT,
  EXTRA_VARIANT,
  RATE_TYPE_NEW,
  RESTRICTIONS_TYPE,
  TRAVEL_WINDOW_TYPE,
  AVAILABILITY,
} from "../../Common/constants";
import moment from "moment";
import "./customStyles.css";
import { withPropertyData } from "../../../../components/property-admin-data-provider";

const messages = defineMessages({
  room: {
    id: "app.smartSelector.room",
    description: "room",
    defaultMessage: "room",
  },
  person: {
    id: "app.smartSelector.person",
    description: "person",
    defaultMessage: "person",
  },
  unit: {
    id: "app.smartSelector.unit",
    description: "unit",
    defaultMessage: "unit",
  },
  perDay: {
    id: "app.smartSelector.perDay",
    description: "unit",
    defaultMessage: "unit",
  },
  mandatory: {
    id: "app.smartSelector.mandatory",
    description: "unit",
    defaultMessage: "unit",
  },
  perDayMandatory: {
    id: "app.smartSelector.perDayMandatory",
    description: "unit",
    defaultMessage: "unit",
  },
  specificDate: {
    id: "app.smartSelector.specificDate",
    description: "unit",
    defaultMessage: "unit",
  },
  blockTypePerDay: {
    id: "app.smartSelector.blockType.perDay",
    description: "Per day",
    defaultMessage: "Per day",
  },
  blockTypePerStay: {
    id: "app.smartSelector.blockType.perStay",
    description: "Per stay",
    defaultMessage: "Per stay",
  },
  own: {
    id: "extraTable.own",
    description: "Own",
    defaultMessage: "Own",
  },
});

function customEntityToListValuesMapper({ entities, currentLocale, intl }) {
  return entities.map(originalEntity => {
    const entity = { ...originalEntity };

    const name =
      entity.translations &&
      entity.translations.find(translation => translation.locale === currentLocale);
    const description =
      entity.translations &&
      entity.translations.find(translation => translation.locale === currentLocale);

    const returnValueIfTypeConstant = keyword =>
      entity.restrictions &&
      entity.restrictions[keyword] &&
      entity.restrictions[keyword].value.type === RESTRICTIONS_TYPE.CONSTANT
        ? entity.restrictions[keyword].value.value
        : "";

    let minStay = returnValueIfTypeConstant("minStay");
    let maxStay = returnValueIfTypeConstant("maxStay");
    if (minStay) {
      minStay = minStay / 24;
    }
    if (maxStay) {
      maxStay = maxStay / 24;
    }
    const minNotice = returnValueIfTypeConstant("minNotice");
    const maxNotice = returnValueIfTypeConstant("maxNotice");
    const promoCode = returnValueIfTypeConstant("code");

    let type = "";
    let validity = "";
    let rate = "";

    switch (entity.type) {
      case EXTRA_TYPE.ROOM:
        type = intl.formatMessage(messages.room);
        break;
      case EXTRA_TYPE.PERSON:
        type = intl.formatMessage(messages.person);
        break;
      case EXTRA_TYPE.UNIT:
        type = intl.formatMessage(messages.unit);
        break;
      default:
        break;
    }
    entity.lockType =
      entity.lockType === EXTRA_TYPE_VARIANT.LOCK_TYPE_STAY
        ? intl.formatMessage(messages.blockTypePerStay)
        : intl.formatMessage(messages.blockTypePerDay);

    if (entity.variant) {
      switch (entity.variant) {
        case EXTRA_VARIANT.MANDATORY:
          type = `${type}${intl.formatMessage(messages.mandatory)}`;
          break;
        case EXTRA_VARIANT.PER_DAY:
          type = `${type}${intl.formatMessage(messages.perDay)}`;
          break;
        case EXTRA_VARIANT.PER_DAY_MANDATORY:
          type = `${type}${intl.formatMessage(messages.perDayMandatory)}`;
          break;
        case EXTRA_VARIANT.SPECIFIC_DATE:
          type = `${type}${intl.formatMessage(messages.specificDate)}`;
          break;
        default:
          break;
      }
    }
    if (
      entity.restrictions &&
      entity.restrictions.travelWindow &&
      entity.restrictions.travelWindow.value.type === TRAVEL_WINDOW_TYPE.CONSTANT
    ) {
      const date = keyword =>
        entity.restrictions.travelWindow.value.value &&
        entity.restrictions.travelWindow.value.value.period[0].dateRange[keyword]
          ? moment(
              entity.restrictions.travelWindow.value.value.period[0].dateRange[keyword],
              "YYYY-MM-DD"
            ).format("DD/MM/YYYY")
          : undefined;

      const start = date("start");
      const end = date("end");

      validity = `${start}
      ${end}`;
    }

    if (entity.rate.type === RATE_TYPE_NEW.CONSTANT) {
      rate = entity.rate.value;
    } else {
      rate = entity.ticker;
    }

    entity.name = name && name.name;
    entity.description = description && description.description;
    entity.type = type;
    entity.rate = rate;
    entity.validity = validity;
    entity.availability =
      entity.restrictions &&
      entity.restrictions.availability &&
      entity.restrictions.availability.value.type === AVAILABILITY.SHARED &&
      entity.restrictions.availability.value.value;
    entity.blocking =
      entity.restrictions &&
      entity.restrictions.blockage &&
      entity.restrictions.blockage.value.type === BLOCKAGE.SHARED &&
      entity.restrictions.blockage.value.value;
    entity.minStay = minStay;
    entity.maxStay = maxStay;
    entity.minNotice = minNotice;
    entity.maxNotice = maxNotice;
    entity.promoCode = promoCode;
    if (
      entity.restrictions &&
      entity.restrictions.availability &&
      entity.restrictions.availability.value
    ) {
      if (entity.restrictions.availability.value.type === AVAILABILITY.SHARED) {
        entity.availability = entity.restrictions.availability.value.value;
      }
      if (entity.restrictions.availability.value.type === AVAILABILITY.OWN) {
        entity.availability = intl.formatMessage(messages.own);
      }
    }
    if (!entity.originalEntity) {
      entity.originalEntity = { ...originalEntity };
    }

    return entity;
  });
}
class ExtrasList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      entities: [],
    };
    this.handleToggle = this.handleToggle.bind(this);
  }

  componentDidMount() {}

  componentWillUnmount() {}

  handleToggle = ({ event, field, entity }) => {
    event.preventDefault();
    event.stopPropagation();

    this.props.onToggleListItem({
      id: entity.id,
      entity: entity.originalEntity,
      activeProperty: "active",
    });
  };
  handleDelete = ({ event, entity }) => {
    event.preventDefault();
    event.stopPropagation();
    console.log("deleted ");
    console.log(entity);
    return this.props.onDeleteListItem({
      id: entity.id,
      entity,
    });
  };

  handleClone = props => this.props.onCloneListItem(props);

  render() {
    const { config } = this.props;
    const { name, entityName, validation, fields, renderers, locale, allowClone, reorder } = config;

    const {
      entities,
      loading,
      entityError,
      entityResult,
      handleCreate,
      handleEdit,
      success,
    } = this.props;
    const { handleToggle, handleDelete } = this;

    return (
      <EntityList
        loading={loading}
        entityName={entityName}
        entities={entities}
        validation={validation}
        renderers={renderers}
        name={name}
        fields={fields}
        onToggle={handleToggle}
        onDelete={handleDelete}
        onClone={this.handleClone}
        entityError={entityError}
        entityResult={entityResult}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
        allowCreate
        allowDelete
        customEntityToListValuesMapper={customEntityToListValuesMapper}
        currentLocale={locale}
        reorder={reorder}
        onReorder={this.props.onReorderListItem}
        success={success}
        allowClone={allowClone}
        horizontalScroll
      />
    );
  }
}

ExtrasList.propTypes = {};

ExtrasList.defaultProps = {
  entities: [],
};

export default withPropertyData(ExtrasList);
